import { RootState } from "store";

export const snackbarSelector = (state: RootState) => state.snackbars;
